// Sales pricing calculator (Gravity admin-settings/pricing). One field list drives the Defaults tab,
// the calculator's knobs, and the API's validation of saved defaults, so the three cannot drift.
//
// Constants are list prices and commission rules; they are edited only in the Defaults tab.
// Starting values are where the calculator's knobs sit when it opens or is reset.
// `seed` is the value used until an admin saves defaults for the first time.

export const PRICING_CALCULATOR_CONSTANT_FIELDS = [
  { key: 'standardConnectorPrice', label: 'Standard connector', unit: 'usdPerYear', seed: 5000, step: 100 },
  { key: 'premiumConnectorPrice', label: 'Premium connector (e.g. NetSuite)', unit: 'usdPerYear', seed: 10000, step: 100 },
  { key: 'builderPrice', label: 'Analytics builder', unit: 'usdPerYear', seed: 1920, step: 10 },
  { key: 'viewerPrice', label: 'Analytics viewer', unit: 'usdPerYear', seed: 120, step: 5 },
  { key: 'proSeatPrice', label: 'Cirra Pro seat', unit: 'usdPerYear', seed: 2400, step: 100 },
  { key: 'standardSeatPrice', label: 'Cirra Standard seat', unit: 'usdPerYear', seed: 360, step: 12 },
  { key: 'premiumMinimumSpend', label: 'Minimum annual spend to unlock premium connectors', unit: 'usd', seed: 10000, step: 500 },
  { key: 'commissionPct', label: 'Sales commission', unit: 'percent', seed: 10, step: 0.5, max: 100 },
  { key: 'aiCommissionPct', label: 'Commission on AI portion, as % of the normal rate', unit: 'percent', seed: 50, step: 5, max: 100 }
];

export const PRICING_CALCULATOR_STARTING_VALUE_FIELDS = [
  { key: 'standardConnectors', label: 'Standard connectors', unit: 'count', seed: 5, step: 1, sliderMax: 200 },
  { key: 'premiumConnectors', label: 'Premium connectors', unit: 'count', seed: 0, step: 1, sliderMax: 50 },
  { key: 'builders', label: 'Analytics builders', unit: 'count', seed: 5, step: 1, sliderMax: 100 },
  { key: 'viewers', label: 'Analytics viewers', unit: 'count', seed: 50, step: 5, sliderMax: 1000 },
  { key: 'markdownPct', label: 'Markdown on connectors and analytics seats', unit: 'percent', seed: 0, step: 1, sliderMax: 95, max: 100 },
  { key: 'proSeats', label: 'Cirra Pro seats', unit: 'count', seed: 5, step: 1, sliderMax: 100 },
  { key: 'standardSeats', label: 'Cirra Standard seats', unit: 'count', seed: 0, step: 1, sliderMax: 200 },
  { key: 'sharedUsagePerMonth', label: 'Shared usage / overflow per month', unit: 'usdPerMonth', seed: 1000, step: 100, sliderMax: 20000 }
];

export const PRICING_CALCULATOR_FIELDS = [...PRICING_CALCULATOR_CONSTANT_FIELDS, ...PRICING_CALCULATOR_STARTING_VALUE_FIELDS];
